import React from 'react';
import { Camera, MapPin, CheckCircle2 } from 'lucide-react';
import {  FaCalendar } from 'react-icons/fa';

export default function ProfileSidebar({ tp, profileImage, talentAge, handleEditProfile }) {
  return (
    <div className="col-12 col-lg-3 d-flex flex-column gap-3">
      {/* Profile Card */}
      <div className="card-dark cp-profile-card">
        <div className="cp-image-container">
          {profileImage ? (
            <img src={profileImage} className="cp-avatar-img w-100" alt="Profile" />
          ) : (
            <div className="cp-no-image w-100">No Image</div>
          )}
          <div className="position-absolute top-0 end-0 p-2">
            <span className="badge bg-success bg-opacity-75 text-white rounded-pill px-2 py-1 cp-verified-badge">
              <CheckCircle2 size={12} className="me-1" /> Verified
            </span>
          </div>
          <div className="position-absolute bottom-0 end-0 p-2">
            <button className="btn btn-sm btn-dark rounded-circle cp-edit-img-btn p-2" onClick={handleEditProfile}>
              <Camera size={16} />
            </button>
          </div>
        </div>
        <div className="p-3 text-center">
          <h5 className="fw-bold mb-1 d-flex align-items-center justify-content-center gap-1 cp-name-title text-white">
            {tp.fullName || 'Candidate Name'} <CheckCircle2 size={16} className="text-danger" />
          </h5>
          <div className="cp-subtitle mb-3 text-muted">{tp.specialCategory || 'Actor • Model • Performer'}</div>
          
          <div className="d-flex justify-content-between py-2 mb-3 text-muted cp-meta-box">
            <div className="cp-meta-item">
              <div className="mb-1"><FaCalendar size={14} /> {talentAge} Years</div>
              <div>DOB: {tp.dateOfBirth || '---'}</div>
            </div>
            <div className="cp-meta-item border-start border-secondary ps-3">
              <div className="mb-1">{tp.height ? `${tp.height} cm` : '---'}</div>
              <div>Height</div>
            </div>
            <div className="cp-meta-item border-start border-secondary ps-3">
              <div className="mb-1"><MapPin size={14} /> {tp.district || tp.state || 'Mumbai'}</div>
              <div>Location</div>
            </div>
          </div>
        </div>
      </div>

      {/* Quick Info Card */}
      <div className="card-dark">
        <div className="fw-bold mb-3 text-white fs-6">Quick Info</div>
        <ul className="cp-list cp-quick-info-list">
          <li className="cp-list-item"><span className="cp-label">Gender</span><span className="cp-val">{tp.gender || '---'}</span></li>
          <li className="cp-list-item"><span className="cp-label">Body Type</span><span className="cp-val">{tp.bodyType || '---'}</span></li>
          <li className="cp-list-item"><span className="cp-label">Hair Color</span><span className="cp-val">{tp.hairColor || '---'}</span></li>
          <li className="cp-list-item"><span className="cp-label">Eyes</span><span className="cp-val">{tp.eyeColour || '---'}</span></li>
          <li className="cp-list-item"><span className="cp-label">Skin Tone</span><span className="cp-val">{tp.skinType || '---'}</span></li>
          <li className="cp-list-item"><span className="cp-label">Education</span><span className="cp-val">{tp.educationLevel || '---'}</span></li>
          <li className="cp-list-item"><span className="cp-label">Nationality</span><span className="cp-val">{tp.nationality || '---'}</span></li>
        </ul>
      </div>

      {/* Basic Details Card */}
      <div className="card-dark">
        <div className="fw-bold mb-3 text-white fs-6">Basic Details</div>
        <ul className="cp-list cp-basic-details-list">
          <li className="cp-list-item"><span className="cp-label">Full Name</span><span className="cp-val">{tp.fullName || '---'}</span></li>
          <li className="cp-list-item"><span className="cp-label">Date of Birth</span><span className="cp-val">{tp.dateOfBirth || '---'}</span></li>
          <li className="cp-list-item"><span className="cp-label">Email</span><span className="cp-val">{tp.email || '---'}</span></li>
          <li className="cp-list-item"><span className="cp-label">Mobile</span><span className="cp-val">{tp.mobileNumber || '---'}</span></li>
          <li className="cp-list-item"><span className="cp-label">Currency</span><span className="cp-val">{tp.preferredCurrency || 'INR'}</span></li>
        </ul>
      </div>
    </div>
  );
}